import { createReducer } from 'redux-act';
import {
  PROGRAMMATIC_VENDOR_FETCH_INIT,
  PROGRAMMATIC_VENDOR_FETCH_SUCCESS,
  PROGRAMMATIC_VENDOR_FETCH_FAIL,
  PROGRAMMATIC_VENDOR_CREATE_INIT,
  PROGRAMMATIC_VENDOR_CREATE_SUCCESS,
  PROGRAMMATIC_VENDOR_CREATE_FAIL,
  PROGRAMMATIC_VENDOR_UPDATE_INIT,
  PROGRAMMATIC_VENDOR_UPDATE_SUCCESS,
  PROGRAMMATIC_VENDOR_UPDATE_FAIL,
  PROGRAMMATIC_VENDOR_DELETE_INIT,
  PROGRAMMATIC_VENDOR_DELETE_SUCCESS,
  PROGRAMMATIC_VENDOR_DELETE_FAIL,
  PROGRAMMATIC_VENDOR_CLEAR,
} from 'state/actions/programmaticVendor';

const initialState = {
  list: [],
  vendor: null,
  loading: false,
  error: null,
};

const upsert = (list, vendor) => {
  if (!vendor?._id) return list;
  const exists = list.some((v) => v._id === vendor._id);
  return exists
    ? list.map((v) => (v._id === vendor._id ? vendor : v))
    : [...list, vendor];
};

export const programmaticVendorReducer = createReducer(
  {
    [PROGRAMMATIC_VENDOR_FETCH_INIT]: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
    [PROGRAMMATIC_VENDOR_FETCH_SUCCESS]: (state, { list, vendor }) => ({
      ...state,
      loading: false,
      error: null,
      list: list || state.list,
      vendor: vendor !== undefined ? vendor : state.vendor,
    }),
    [PROGRAMMATIC_VENDOR_FETCH_FAIL]: (state, { error }) => ({
      ...state,
      loading: false,
      error,
    }),

    [PROGRAMMATIC_VENDOR_CREATE_INIT]: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
    [PROGRAMMATIC_VENDOR_CREATE_SUCCESS]: (state, { vendor }) => ({
      ...state,
      loading: false,
      error: null,
      list: upsert(state.list, vendor),
    }),
    [PROGRAMMATIC_VENDOR_CREATE_FAIL]: (state, { error }) => ({
      ...state,
      loading: false,
      error,
    }),

    [PROGRAMMATIC_VENDOR_UPDATE_INIT]: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
    [PROGRAMMATIC_VENDOR_UPDATE_SUCCESS]: (state, { vendor }) => ({
      ...state,
      loading: false,
      error: null,
      list: upsert(state.list, vendor),
    }),
    [PROGRAMMATIC_VENDOR_UPDATE_FAIL]: (state, { error }) => ({
      ...state,
      loading: false,
      error,
    }),

    [PROGRAMMATIC_VENDOR_DELETE_INIT]: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
    [PROGRAMMATIC_VENDOR_DELETE_SUCCESS]: (state, { id }) => ({
      ...state,
      loading: false,
      error: null,
      list: state.list.filter((v) => v._id !== id),
    }),
    [PROGRAMMATIC_VENDOR_DELETE_FAIL]: (state, { error }) => ({
      ...state,
      loading: false,
      error,
    }),

    [PROGRAMMATIC_VENDOR_CLEAR]: () => initialState,
  },
  initialState
);
